import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const storageKey = 'analyticsScope'

interface State {
  // Empty means every portal the caller owns. The full list is not known until getMe answers,
  // so it is expanded when a query is built rather than stored here.
  selectedPortalIds: string[]
}

function readStoredScope(): string[] {
  try {
    const raw = localStorage.getItem(storageKey)
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed)
      ? parsed.filter((id) => typeof id === 'string')
      : []
  } catch {
    return []
  }
}

function storeScope(ids: string[]) {
  try {
    if (ids.length) localStorage.setItem(storageKey, JSON.stringify(ids))
    else localStorage.removeItem(storageKey)
  } catch {
    // A blocked or full store only costs the selection its persistence.
  }
}

const initialState: State = { selectedPortalIds: readStoredScope() }

const analyticsScopeSlice = createSlice({
  name: 'analyticsScope',
  initialState,
  reducers: {
    setAnalyticsScope(state, action: PayloadAction<string[]>) {
      state.selectedPortalIds = action.payload
      storeScope(action.payload)
    }
  }
})

export const { setAnalyticsScope } = analyticsScopeSlice.actions
export default analyticsScopeSlice.reducer
